import React from 'react';
import { RpmConsentStatus } from './consentStatusIcons/RpmConsentStatus';
import { CcmConsentStatus } from './consentStatusIcons/CcmConsentStatus';
export const ReviewConsent = ({ patient, onOpenModal, isPatientHub }) => {
    var rpmConsent = 'No Consent';
    var ccmConsent = 'No Consent';
    if (patient.rpmConsentedAt && !patient.rpmConsent) {
        rpmConsent = 'Opt Out';
    }
    if (patient.ccmConsentedAt && !patient.ccmConsent) {
        ccmConsent = 'Opt Out';
    }
    if (patient.rpmConsent) {
        rpmConsent = 'Consented';
    }
    if (patient.ccmConsent) {
        ccmConsent = 'Consented';
    }
    return (React.createElement("div", { className: "text-center", style: { marginLeft: 'auto' } },
        React.createElement("div", { className: isPatientHub ? 'flex' : 'block', onClick: onOpenModal },
            React.createElement("div", { style: { margin: '3px' } },
                React.createElement(RpmConsentStatus, { consentStatus: rpmConsent })),
            React.createElement("div", { style: { margin: '3px' } },
                React.createElement(CcmConsentStatus, { consentStatus: ccmConsent })))));
};
